module.exports = __webpack_public_path__ + "h5/img/collection-info-bg.edc2ce99.png";